import { useEffect, useState } from 'react';

export const ACCESS_WAIT_MS = 3000;

/**
 * KAN-827 — true once the company-access read has stayed 'loading' for 3s. A
 * surface that holds for the lock level (the /log-job door, the Office Inbox
 * greeting) gives up then and proceeds as for an unlocked company: client UX
 * only, the server is the boundary. Resets when the status leaves 'loading'.
 */
export default function useAccessWaitGaveUp(status, ms = ACCESS_WAIT_MS) {
  const [gaveUp, setGaveUp] = useState(false);
  useEffect(() => {
    if (status !== 'loading') { setGaveUp(false); return undefined; }
    const t = setTimeout(() => setGaveUp(true), ms);
    return () => clearTimeout(t);
  }, [status, ms]);
  return gaveUp;
}
